import { CustomerSettingsMessage } from '../../../types/CustomerSettingsMessage';
import { useToasts } from '../../cdl/Toast/useToasts';
import { updateCustomerSettings } from '../../common/api/clients/companySettings.api';
import { queries } from '../../common/api/queryKeys/queries';
import { translate } from '../../common/helpers/translate.helper';
import { useOptimisticMutation } from '../../common/hooks/useOptimisticMutation';

import { UpdateCustomerSettingsVariables } from './types';

export const useCustomerSettingsOptimisticMutation = (customerId: string) => {
    const { addErrorToast } = useToasts();

    return useOptimisticMutation<
        CustomerSettingsMessage,
        Error,
        UpdateCustomerSettingsVariables,
        CustomerSettingsMessage
    >({
        mutationFn: updateCustomerSettings,
        optimisticUpdateOptions: {
            queryKey: queries.customers.detail(customerId)._ctx.settings.queryKey,
            optimisticUpdatesFn: ({ prevQueryData, variables }) => {
                return {
                    ...prevQueryData,
                    ...variables.settings,
                };
            },
            invalidateQueryOnSuccess: true,
        },
        onError: () => {
            addErrorToast(translate('company.toasts.informationUpdateError'));
        },
    });
};
